import styled from '@emotion/styled'

import { mediaQueryUp } from '~/utils/grid'

import { BaseCarouselButton } from '~/shared/molecules/Carousel/CarouselUtils'

export const CarouselWrapper = styled.div`
  position: relative;
  width: 100%;

  ${mediaQueryUp('l')} {
    border-radius: 0.5rem;
    overflow: hidden;
  }
`

export const StyledCarouselContent = styled.div`
  overflow: hidden;

  & > div:first-of-type {
    display: flex;
  }
`

export const StyledCarouselItem = styled.div`
  min-width: 0;
  flex: 0 0 100%;
`

export const EmblaDots = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  z-index: 10;
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;

  z-index: 1;
  pointer-events: all;
`

export const EmblaDot = styled.button<{ selected: boolean; isSmall: boolean }>`
  -webkit-tap-highlight-color: rgba(49, 49, 49, 0.5);
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;
  touch-action: manipulation;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  cursor: pointer;
  border: 0;
  padding: 0;
  margin: 0;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  position: relative;

  &::after {
    content: ' ';
    background: #ffffff;
    width: 0.5rem;
    height: 0.5rem;

    border-radius: 50%;
    display: flex;
    align-items: center;
    opacity: 0.5;
  }

  ${({ selected }) =>
    selected &&
    `
    &::after {
  opacity: 1;

  animation: scale 0.1s ease-in;

  @keyframes scale {
    50% {
      transform: scale(0.75);
    }
    0%,
    100% {
      transform: scale(1);
    }
  }
}
  `}

  ${({ isSmall }) =>
    isSmall &&
    `
     &::after {
        width: 0.25rem;
        height: 0.25rem;
    }
  `}
`

export const CarouselButtonsWrapper = styled.div`
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  display: none;
  justify-content: space-between;
  position: absolute;
  left: 0;
  z-index: 1;
  padding: 0 1rem;

  ${mediaQueryUp('m')} {
    display: flex;
  }
`

export const StyledCarouselButton = styled(BaseCarouselButton)`
  display: flex;
  padding: 0;
  margin: 0;
  cursor: pointer;
  box-shadow: ${({ theme }) => theme.commons.shadow.m};
  background: #ffffff;

  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  opacity: 0.8;

  img {
    height: 1.75rem;
    filter: brightness(0) saturate(100%) invert(44%) sepia(3%) saturate(32%) hue-rotate(314deg) brightness(96%) contrast(89%);
  }

  &:last-child img {
    transform: rotate(180deg);
  }
`

export const CarouselImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 55.55%; // (100 / 1.8 = 55.55)

  & > :first-child {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`
